import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import FilterBar from '../components/FilterBar';
import { motion } from 'framer-motion';

const Home = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-[85vh] w-full flex items-center justify-center overflow-hidden">
        {/* Background Image with Parallax Effect */}
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1626227438613-d9e208327367?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxtYWxkaXZlcyUyMGx1eHVyeSUyMHJlc29ydCUyMGFlcmlhbCUyMG9jZWFufGVufDB8fHx8MTc2ODY1NDk4MHww&ixlib=rb-4.1.0&q=85" 
            alt="Maldives Aerial" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent h-48 bottom-0" />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center text-white space-y-8">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="text-5xl md:text-7xl font-heading font-bold tracking-tight leading-tight"
          >
            Find Your Perfect <br/>
            <span className="italic font-normal font-accent">Island Escape</span>
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="text-lg md:text-xl font-light text-white/90 max-w-2xl mx-auto leading-relaxed"
          >
            Use AI to search across 150+ resorts. Tell us exactly what you want—down to the slide, the sunset, and the coral reef.
          </motion.p>

          <div className="pt-8">
            <FilterBar />
          </div>
        </div>
      </section>

      {/* Featured Section */}
      <section className="py-24 px-6 md:px-12 max-w-7xl mx-auto">
        <div className="flex justify-between items-end mb-16">
          <div>
            <span className="text-accent text-sm font-bold tracking-[0.2em] uppercase">Curated Collection</span>
            <h2 className="text-4xl font-heading font-medium mt-4 text-primary">Trending This Season</h2>
          </div>
          <a href="/search" className="hidden md:block text-sm font-bold tracking-widest uppercase border-b border-primary pb-1 hover:text-accent hover:border-accent transition-colors">
            View All Collections
          </a>
        </div>
        
        {/* Placeholder for featured items - reused search cards or simple images */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[1, 2, 3].map((i) => (
             <div key={i} className="group relative aspect-[4/5] overflow-hidden rounded-xl bg-gray-100">
               <img 
                 src={`https://images.unsplash.com/photo-1698726654862-377c0218dfdc?random=${i}`} 
                 className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                 alt="Featured"
               />
               <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-8">
                 <div className="text-white">
                   <h3 className="text-xl font-heading">The Royal Residence</h3>
                   <p className="text-sm opacity-80 mt-1">St. Regis Vommuli</p>
                 </div>
               </div>
             </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Home;
